import { useCampaignSlug } from '@/components/Functional/hooks-core/useCampaignSlug'
import { useUserDeviceUuid } from '@/components/Functional/hooks-core/useUserDeviceUuid'
import {
  type CampaignHeaders,
  type CampaignHeadersWithAuthorization,
  getHeaders,
  getHeadersWithAuthorization,
} from '@/components/Functional/utils/getHeader'
import { PUBLIC_PAGE_DEFAULT_LOCALE, resolveLocale } from '@/components/Functional/utils/publicPageLocale'
import { useTokenStore } from '@/store/useTokenStore'

/**
 * headers: Authorizationなしのヘッダー
 * headersWithAuthorization: Authorizationありのヘッダー
 */
export const useCampaignHeaders = (): {
  headers: CampaignHeaders
  headersWithAuthorization: CampaignHeadersWithAuthorization
} => {
  const { LOCAL_STORAGE_I18N_KEY, campaignSlug } = useCampaignSlug()
  const { uuid } = useUserDeviceUuid()
  const idToken = useTokenStore((s) => s.idToken)
  if (typeof window === 'undefined') {
    return {
      headers: getHeaders({ campaignSlug, uuid, locale: PUBLIC_PAGE_DEFAULT_LOCALE }),
      headersWithAuthorization: getHeadersWithAuthorization({
        campaignSlug,
        uuid,
        locale: PUBLIC_PAGE_DEFAULT_LOCALE,
        idToken: '',
      }),
    }
  }

  // Auth / Docs 画面へのリンクに付ける `lang` クエリ（#3504）と同じ値を使うため、
  // ロケールの決定は resolveLocale() に一本化している
  const locale = resolveLocale(LOCAL_STORAGE_I18N_KEY)
  return {
    headers: getHeaders({ campaignSlug, uuid, locale }),
    headersWithAuthorization: getHeadersWithAuthorization({ campaignSlug, uuid, locale, idToken: idToken || 'none' }),
  }
}
